/**
 * Sandbox utilities — helpers for overlay and diff computation.
 */
import type { AtlasManifest } from '@atlas-manifest/types';

/**
 * Compute the set of entity IDs that exist in overlayManifest but not in baseManifest.
 * Used to identify which simulation steps write "sandbox-only" entities that haven't been
 * committed to the main manifest yet.
 */
export function getSandboxOnlyEntities(
  baseManifest: AtlasManifest,
  overlayManifest: AtlasManifest,
): Set<string> {
  const baseIds = new Set(baseManifest.entities.map((e) => e.id));
  const overlayOnlyIds = new Set<string>();

  for (const entity of overlayManifest.entities) {
    if (!baseIds.has(entity.id)) {
      overlayOnlyIds.add(entity.id);
    }
  }

  return overlayOnlyIds;
}
